/* eslint-disable no-nested-ternary */
import Image from '../Image';
import SwiperBasic from '../Swiper/SwiperBasic';
import { Tit } from '../Titles';
import { anniversarySupportVo } from '@/__generated__/FrontApi';
import IconPen from '@/assets/img/icons/ico_pen@2x.png';
import { breakpoint } from '@/helpers/BreakpointHelper';
import React, { FC } from 'react';
import styled from 'styled-components';
// eslint-disable-next-line import/order
import SwiperCore, { A11y, Autoplay, Navigation, Scrollbar } from 'swiper';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/components/scrollbar/scrollbar.min.css';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.min.css';

SwiperCore.use([Navigation, Scrollbar, A11y, Autoplay]);

interface TogeterProps {
  campaigns: anniversarySupportVo[];
  img?: boolean;
  overflowHidden?: boolean;
  autoplay?: boolean;
}

const CardLayout = styled.div`
  ${Tit} {
    width: 100%;
    margin-top: 32px;
    line-height: 1.6;
    small {
      font-size: 16px;
      display: block;
      margin-top: 16px;
      font-weight: 400;
    }
  }
`;
const CardImage = styled.div`
  position: relative;

  .img-box {
    width: 100%;
    padding-top: 55.7%;
    border-radius: 0 0 40px 0;
    box-shadow: 12px 10px 26.46px 0.54px rgba(0, 0, 0, 0.11);
    ${breakpoint(`mobile`)} {
      border-radius: 0 0 20px 0;
      box-shadow: 6px 5px 13.23px 0.27px rgba(0, 0, 0, 0.11);
    }
  }

  .card-img {
    max-width: 100%;
    width: 100%;
  }
`;

const SwiperCustom = styled(SwiperBasic)`
  padding: 0;
  .swiper-container {
    padding: 65px 0 236px;

    ${breakpoint(`mobile`)} {
      padding: 44px 0;
    }

    .swiper-scrollbar {
      bottom: 166px;
      &::before {
        opacity: 1;
      }
    }

    ${breakpoint(`tablet`)} {
      width: 100%;
      left: 0;
    }
    .swiper-button-next,
    .swiper-button-prev {
      transform: translateX(35px);
      bottom: 140px;
    }

    .swiper-slide {
      ${breakpoint(1160)} {
        width: 41.03vw;
        // margin-right: 3.45vw;
      }
    }

    .dec-wrap {
      text-align: center;
      ${Tit} {
        font-size: 18px;
        line-height: 1.55;
        text-align: center;
        padding: 0 45px;
        min-height: 140px;
      }
      .dec-name {
        background: url('${IconPen}') no-repeat right;
        background-size: 23px;
        padding: 0 22px;
        display: inline-block;
        max-width: calc(100% - 45px);
        margin: 64px auto 0;
        > strong {
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 100%;
          border-bottom: 2px solid #1cabe2;
          font-size: 16px;
          line-height: 34px;
          color: #1cabe2;
          text-align: center;
          padding: 0 6px;
        }
      }
      ${breakpoint(`tablet`)} {
        ${Tit} {
          font-size: 1.82vw;
          padding: 0 20px;
          min-height: 13.12vw;
        }
        .dec-name {
          max-width: calc(100% - 15px);
          > strong {
            font-size: 1.61vw;
          }
        }
      }
      ${breakpoint(`mobile`)} {
        ${Tit} {
          font-size: 14px;
          padding: 0 25px;
          margin: 20px 0 15px;
          min-height: auto;
        }
        .dec-name {
          background-size: 18px;
          margin: 5px auto 0;
          max-width: 100%;
          padding: 0 17px;
          > strong {
            font-size: 13px;
            line-height: 28px;
            margin: 0 auto;
            padding: 0 10px;
          }
        }
      }
    }
  }
`;

const TogetherCard2: FC<TogeterProps> = ({ campaigns, img, ...props }) => (
  <SwiperCustom {...props}>
    <Swiper
      slidesPerView={2}
      spaceBetween={40}
      navigation
      scrollbar={{ draggable: true }}
      autoplay={props.autoplay}
      breakpoints={{
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        991: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
      }}
      onSwiper={(swiper) => {
        setTimeout(() => {
          swiper.update(); // ------> this solution
        }, 3000);
      }}
    >
      {campaigns.map((items) => (
        <SwiperSlide key={items.indexNumber}>
          <CardLayout className="CardLayout">
            <CardImage className="img-wrap">
              {img ? (
                <Image
                  className="card-img"
                  pcSrc={items.imgAttGrpNoPc}
                  mobileSrc={items.imgAttGrpNoMob}
                />
              ) : (
                <div
                  className="img-box"
                  css={`
                    background-image: url(${items.imgAttGrpNoPc});
                  `}
                />
              )}
            </CardImage>

            <div className="dec-wrap">
              <Tit
                weight="normal"
                dangerouslySetInnerHTML={{
                  __html: items.summary?.replaceAll('\n', '<br/>') || '',
                }}
              />
              <span className="dec-name">
                <strong>{items.userName || '익명 후원자님'}</strong>
              </span>
            </div>
          </CardLayout>
        </SwiperSlide>
      ))}
    </Swiper>
  </SwiperCustom>
);
export default TogetherCard2;
